import { render, staticRenderFns } from "./SideNavigationWrapper.vue?vue&type=template&id=337deeda&scoped=true&"
import script from "./SideNavigationWrapper.vue?vue&type=script&lang=js&"
export * from "./SideNavigationWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337deeda",
  null
  
)

export default component.exports